require('./bootstrap');

import {createApp, defineAsyncComponent} from "vue";
import store from './vue/store/store';
import number from "@coders-tm/vue-number-format";
import { Form } from 'vform'
import { ZiggyVue } from '../../vendor/tightenco/ziggy/src/js/vue';
import { SwalConfirm } from "./vue/methods/alert/confirmation";
import dayjs from "dayjs";

window.Form = Form;

const app = createApp({});

app.config.globalProperties.$swalConfirm = SwalConfirm;

app.config.globalProperties.$filters = {
    dayjs(date, format = 'DD/MM/YYYY') {
        return dayjs(date).format(format)
    }
}

app.use(ZiggyVue, Ziggy);
app.use(store);
app.use(number, {
    "decimal": ".",
    "separator": ",",
    "prefix": "",
    "suffix": "",
    "precision": 4,
    "nullValue": "0",
    "masked": false,
    "reverseFill": false,
    "min": "0"
});

app.component(
    "HasError",
    defineAsyncComponent(() => import(/* webpackChunkName: "alert/has-error"*/ "vform/src/components/bootstrap4"))
);

app.component(
    "AlertError",
    defineAsyncComponent(() => import(/* webpackChunkName: "alert/alert-error"*/ "vform/src/components/bootstrap4"))
);

app.component(
    "AlertErrors",
    defineAsyncComponent(() => import(/* webpackChunkName: "alert/alert-errors"*/ "vform/src/components/bootstrap4"))
);

app.component(
    "AlertSuccess",
    defineAsyncComponent(() => import(/* webpackChunkName: "alert/alert-errors"*/ "vform/src/components/bootstrap4"))
);

app.component(
    "VueMultiselect",
    defineAsyncComponent(() => import(/* webpackChunkName: "vue-multiselect"*/ "vue-multiselect"))
);

// app.component('session-form', SessionForm);
app.component(
    "session-form",
    defineAsyncComponent(() => import(/* webpackChunkName: "session/session-form"*/ "./vue/components/session/Form.vue"))
);

app.component(
    "invoice-detail",
    defineAsyncComponent(() => import(/* webpackChunkName: "invoice/invoice-detail"*/ "./vue/components/InvoiceDetail.vue"))
);

app.component(
    'item-row',
    defineAsyncComponent(() => import(/* webpackChunkName: "invoice/item-row" */ "./vue/components/invoice/itemRow.vue"))
);

app.component(
    'payment-row',
    defineAsyncComponent(() => import(/* webpackChunkName: "invoice/payment-row" */ "./vue/components/invoice/paymentRow.vue"))
);

app.component(
    'payment-method-form',
    defineAsyncComponent(() => import(/* webpackChunkName: "invoice/payment-method-form" */ "./vue/components/invoice/paymentMethodForm.vue"))
);

app.component(
    'extra-item-form',
    defineAsyncComponent(() => import(/* webpackChunkName: "invoice/extra-item-form" */ "./vue/components/invoice/extraItemForm.vue"))
);

app.component(
    'segmentation-form',
    defineAsyncComponent(() => import(/* webpackChunkName: "segmentation/segmentation-form" */ "./vue/components/segmentation/Form.vue"))
);

app.component(
    'trigger-form',
    defineAsyncComponent(() => import(/* webpackChunkName: "mail-campaign/trigger-form" */ "./vue/components/MailCampaign/TriggerForm.vue"))
);

app.component(
    'booking-form',
    defineAsyncComponent(() => import(/* webpackChunkName: "booking/booking-form" */ "./vue/components/booking/Form.vue"))
);

app.component(
    'session-index-timetable',
    defineAsyncComponent(() => import(/* webpackChunkName: "session/session-index-timetable" */ "./vue/components/session/IndexTimetable.vue"))
);

app.component(
    'resource-payment-advice',
    defineAsyncComponent(() => import(/* webpackChunkName: "resource/resource-payment-advice" */ "./vue/components/resource/PaymentAdvice.vue"))
);

app.component(
    'guest-session-timetable',
    defineAsyncComponent(() => import(/* webpackChunkName: "session/guest-session-timetable" */ "./vue/components/session/GuestTimetable.vue"))
);

app.component(
    'transaction-report',
    defineAsyncComponent(() => import(/* webpackChunkName: "dashboard/report/transaction-report" */ "./vue/components/dashboard/TransactionReport.vue"))
);

app.component(
    'transaction-report-filter',
    defineAsyncComponent(() => import(/* webpackChunkName: "dashboard/report/transaction-report-filter" */ "./vue/components/dashboard/TransactionReportFilter.vue"))
);

app.component(
    'transaction-report-modal',
    defineAsyncComponent(() => import(/* webpackChunkName: "dashboard/report/transaction-report-modal" */ "./vue/components/dashboard/TransactionReportModal.vue"))
);

app.component(
    'class-filter',
    defineAsyncComponent(() => import(/* webpackChunkName: "class/filter" */ "./vue/components/class/Filter.vue"))
);

app.component(
    'room-filter',
    defineAsyncComponent(() => import(/* webpackChunkName: "room/filter" */ "./vue/components/room/Filter.vue"))
);

app.component(
    'resource-filter',
    defineAsyncComponent(() => import(/* webpackChunkName: "resource/filter" */ "./vue/components/resource/Filter.vue"))
);

app.component(
    'session-filter',
    defineAsyncComponent(() => import(/* webpackChunkName: "session/filter" */ "./vue/components/session/Filter.vue"))
);

app.component(
    'booking-filter',
    defineAsyncComponent(() => import(/* webpackChunkName: "booking/filter" */ "./vue/components/booking/Filter.vue"))
);

app.component(
    'invoice-item-credit',
    defineAsyncComponent(() => import(/* webpackChunkName: "invoice/invoice-item-credit" */ "./vue/components/invoice/ItemCreditList.vue"))
);

app.component(
    'session-detail',
    defineAsyncComponent(() => import(/* webpackChunkName: "session/session-detail" */ "./vue/components/session/SessionDetail.vue"))
);

app.component(
    'booking-request-index',
    defineAsyncComponent( () => import(/* webpackChunkName: "booking-request/index" */ "./vue/components/booking-request/Index.vue") )
)

app.component(
    'booking-enquiry-index',
    defineAsyncComponent( () => import(/* webpackChunkName: "booking-enquiry/index" */ "./vue/components/booking-enquiry/Index.vue") )
)

app.component(
    'booking-enquiry-guest-form',
    defineAsyncComponent( () => import(/* webpackChunkName: "booking-enquiry/guest-form" */ "./vue/components/booking-enquiry/BookingEnquiryGuestForm.vue") )
)

app.component(
    'invoice-cover-sheet-detail',
    defineAsyncComponent( () => import(/* webpackChunkName: "invoice-cover-sheet/detail" */ "./vue/components/invoice-cover-sheet/InvoiceCoverSheetDetail.vue"))
)

app.mount('#app');
